<template>
  <div>
    <div class="consultation-header"></div>
    <div class="c consultation-c">
      <el-form
        class="consultation-body"
        :rules="rules"
        ref="formRef"
        @submit.native.prevent="onSubmit"
        :model="form"
        :disabled="consultationId"
      >
        <div class="consultation-body-item">
          <div class="mag-grid xcp-form contacts" style="--linenum: 2">
            <el-form-item prop="contacts">
              <el-input
                v-model="form.contacts"
                size="large"
                placeholder="联系人"
              />
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                v-model="form.phone"
                size="large"
                placeholder="手机号"
              />
            </el-form-item>
            <el-form-item prop="job">
              <el-input v-model="form.job" size="large" placeholder="职位" />
            </el-form-item>
            <el-form-item prop="companyName">
              <el-input
                v-model="form.companyName"
                size="large"
                placeholder="公司名称"
              />
            </el-form-item>
            <el-form-item prop="email">
              <el-input v-model="form.email" size="large" placeholder="邮箱" />
            </el-form-item>
            <el-form-item prop="code" v-if="!consultationId">
              <el-input v-model="form.code" size="large" placeholder="验证码">
                <template slot="append">
                  <el-button @click="sendCode" :loading="sendCodeLoading">
                    {{ time ? `${time}s` : '获取验证码' }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="departureCityCn">
              <el-input
                placeholder="出发城市"
                keyword="config.get_select_data"
                :condition="{
                  dataCo: 'china_city_select'
                }"
                size="large"
                v-model="form.departureCity"
                @change="form.departureCityCn = $event.text"
              ></el-input>
            </el-form-item>
            <el-form-item prop="destinationCountryCn">
              <el-input
                placeholder="目的国家"
                size="large"
                keyword="config.get_select_data"
                :condition="{
                  dataCo: 'scheme_country_select'
                }"
                v-model="form.destinationCountry"
                @change="form.destinationCountryCn = $event.text"
              ></el-input>
            </el-form-item>
            <el-form-item prop="goodsCategory">
              <el-input
                style="width: 100%"
                v-model="form.goodsCategory"
                :options="goodsCategoryOptions"
                @change="handleChange"
                class="goods-category-select"
                placeholder="商品类别"
                size="large"
                clearable
                filterable
                :props="{
                  label: 'name',
                  value: 'name',
                  children: 'children'
                }"
              >
                <template v-if="optionsLoading" slot="empty">
                  加载中...
                </template>
              </el-input>
            </el-form-item>

            <el-form-item prop="companyWebsite">
              <el-input
                v-model="form.companyWebsite"
                size="large"
                placeholder="公司网址"
              />
            </el-form-item>
            <el-form-item prop="contactsRemark" style="--seat: 2">
              <el-input
                v-model="form.contactsRemark"
                size="large"
                placeholder="补充说明"
              />
            </el-form-item>
            <el-form-item style="--seat: 2" v-if="!consultationId">
              <el-button
                class="submit-btn"
                type="primary"
                @click="onSubmit"
                size="large"
              >
                提 交
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
// import { sessionCache } from '@/plugins/cache'
// import router from '@/router'
// import request from '@/utils/request'
// import { Message } from 'element-ui'

export default {
  name: 'Consultation',
  data() {
    return {
      // consultationInfo: sessionCache.getJSON('CONSULTATION_INFO'),
      consultationId: null,
      goodsCategoryOptions: [],
      optionsLoading: false,
      time: 0,
      timer: null,
      sendCodeLoading: false,
      stepList: [],
      services: [],
      form: {},
      rules: {
        etaTime: [
          { required: true, message: '请选择计划到达时间', trigger: 'blur' }
        ],
        etdTime: [
          { required: true, message: '请选择计划发运时间', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    viewStepList() {
      let checkList = this.services.filter(e =>
        (this.form.serviceProcess || []).includes(e.code)
      )
      checkList = [...checkList, ...this.stepList].sort((a, b) => {
        return a.sort - b.sort
      })
      return checkList
    }
  },
  mounted() {
    const { id } = this.$route.query
    if (id) {
      this.consultationId = id
      // request({
      //   url: `/indexBusiness/needsDetail/${id}`,
      //   method: 'post'
      // })
      //   .then(res => {
      //     this.form = {
      //       ...res.data,
      //       goodsCategory: res.data.goodsCategory.split('//'),
      //       serviceProcess: JSON.parse(res.data.serviceProcess)
      //     }
      //     const { providerProductId } = res.data
      //     return request({
      //       url: `/indexBusiness/getProductProcess/${providerProductId}`,
      //       method: 'post'
      //     })
      //   })
      //   .then(res => {
      //     this.stepList = res.data.filter(item => item.required === '1')
      //     this.services = res.data.filter(item => item.required !== '1')
      //   })
    } else {
      if (!this.consultationInfo) {
        // return router.push({
        //   path: '/index'
        // })
      }
      // const { providerProductId } = this.consultationInfo
      this.form = {
        ...this.form,
        ...this.consultationInfo,
        goodsCategory: this.consultationInfo.goodsCategory.split('//')
      }
      // request({
      //   url: `/indexBusiness/getProductProcess/${providerProductId}`,
      //   method: 'post'
      // }).then(res => {
      //   this.stepList = res.data.filter(item => item.required === '1')
      //   this.services = res.data.filter(item => item.required !== '1')
      // })
    }
    this.getSelect()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getSelect() {
      this.optionsLoading = true
      // request({
      //   url: `/category/listTree`,
      //   method: 'post'
      // })
      //   .then(res => {
      //     this.goodsCategoryOptions = res.data
      //   })
      //   .finally(() => {
      //     this.optionsLoading = false
      //   })
    },
    sendCode() {
      if (this.timer) return
      this.$refs.formRef.validateField('email', valid => {
        if (valid) {
          this.sendCodeLoading = true
          // request({
          //   url: `/indexBusiness/getVerifyKey`,
          //   method: 'post',
          //   data: { email: this.form.email }
          // })
          //   .then(res => {
          //     Message.success('验证码已发送')
          //     this.time = 60
          //     this.timer = setInterval(() => {
          //       this.time--
          //       if (this.time <= 0) {
          //         clearInterval(this.timer)
          //         this.timer = null
          //         this.time = null
          //       }
          //     }, 1000)
          //   })
          //   .finally(() => {
          //     this.sendCodeLoading = false
          //   })
        } else {
          // Message.error('请输入正确的邮箱')
          // return
        }
      })
    },
    onSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          // const data = {
          //   ...this.form,
          //   regionCn: `${this.form.countryCn} - ${this.form.regionCn}`,
          //   serviceProcess: JSON.stringify(this.form.serviceProcess),
          //   goodsCategory: this.form.goodsCategory.join('//')
          // }
          // request({
          //   url: `/indexBusiness/addNeeds`,
          //   method: 'post',
          //   data
          // }).then(res => {
          //   if (res.code === 200) {
          //     Message.success('提交成功')
          //     router.push({
          //       path: '/my/demand'
          //     })
          //   }
          // })
        } else {
          // Message.error('请检查必填项')
          return false
        }
      })
    },
    handleChange(value) {
      // 处理级联选择器变化
    }
  }
}
</script>
<style lang="less" scoped>
.mag-grid {
  display: grid;
  --linenum: 3;
  grid-template-columns: repeat(var(--linenum), 1fr);
  grid-gap: 0 20px;
  & > * {
    grid-column: span var(--seat);
  }
}
.consultation-header {
  padding-top: 580px;
  padding-bottom: 24px;
  color: #fff;
  margin-top: calc(0px - 20px);
  background: url(../../assets/consultation/consultation-header.jpg) no-repeat 0 /
    100% 100%;
  text-shadow: #000 1px 1px 10px;
  h3 {
    font-size: 36px;
  }
  ul {
    font-size: 18px;
    margin-top: 8px;
    display: flex;
    gap: 32px;
  }
}
.consultation-c {
  padding: 110px 240px 100px;
  background-color: #000;
  color: #fff;
  :deep(.xcp-form) {
    margin-top: 12px;
    .el-form-item {
      position: relative;
      margin-bottom: 24px;
      &.is-required {
        &::after {
          content: '*';
          position: absolute;
          color: red;
          left: 4px;
          top: 10px;
        }
      }
      .el-form-item__label {
        padding-left: 12px;
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 4px;
      }
      .el-input__wrapper {
        padding-left: 20px;
      }
    }
    .submit-btn {
      width: 100%;
      background-color: transparent;
      border: 1px solid #fff;
      color: #fff;
      border-radius: 0;
      font-weight: 700;
      font-size: 16px;
      margin-top: 8px;
      &:hover {
        // background-color: var(--el-color-primary);
        // border-color: var(--el-color-primary);
      }
    }
  }
}
</style>
